/**
 * Post Navigation block view script.
 *
 * - Default mode: hides on scroll-down, shows after 200px scroll-up or at page bottom.
 * - Always-visible mode: stays fixed, only adjusts when footer enters view.
 *
 * Performance:
 * - No rAF loop — only runs on scroll events via a single passive listener.
 * - Footer clearance uses IntersectionObserver (zero scroll cost) instead of
 *   per-frame getBoundingClientRect.
 * - Scroll handler is debounced to one rAF per frame.
 */

function initPostNavigationScroll() {
	const postNav = document.querySelector( '.wp-block-post-navigation' );
	if ( ! postNav ) return;

	const footer = document.querySelector( '.site-footer, footer.wp-block-template-part' );
	const alwaysVisible = postNav.dataset.alwaysVisible === 'true';
	const SCROLL_UP_THRESHOLD = 200;

	let prevScrollY = window.scrollY;
	let scrollUpAccum = 0;
	let ticking = false;
	let footerIsVisible = false;

	// ── Footer clearance via IntersectionObserver ──
	if ( footer ) {
		const footerObserver = new IntersectionObserver(
			( entries ) => {
				footerIsVisible = entries[ 0 ].isIntersecting;

				if ( footerIsVisible ) {
					const footerRect = footer.getBoundingClientRect();
					const overlap = window.innerHeight - footerRect.top;
					postNav.style.bottom = Math.max( 0, overlap + 8 ) + 'px';
				} else {
					postNav.style.bottom = '';
				}
			},
			{ threshold: [ 0, 0.1, 0.2, 0.3, 0.5, 0.75, 1 ] }
		);

		footerObserver.observe( footer );
	}

	// ── Initial state ──
	if ( alwaysVisible ) {
		postNav.classList.add( 'is-visible' );
	} else {
		postNav.classList.add( 'is-visible' );
	}

	// ── Scroll handler (only for show/hide logic in default mode) ──
	if ( ! alwaysVisible ) {
		const onScroll = () => {
			if ( ticking ) return;
			ticking = true;

			requestAnimationFrame( () => {
				const scrollY = window.scrollY;
				const delta = scrollY - prevScrollY;
				const atBottom = ( scrollY + window.innerHeight ) >= document.documentElement.scrollHeight - 50;

				if ( atBottom ) {
					postNav.classList.add( 'is-visible' );
					postNav.classList.remove( 'is-hidden' );
					scrollUpAccum = 0;
				} else if ( delta > 2 ) {
					// Scrolling down — hide
					postNav.classList.add( 'is-hidden' );
					postNav.classList.remove( 'is-visible' );
					scrollUpAccum = 0;
				} else if ( delta < -2 ) {
					// Scrolling up — accumulate
					scrollUpAccum += Math.abs( delta );
					if ( scrollUpAccum >= SCROLL_UP_THRESHOLD ) {
						postNav.classList.add( 'is-visible' );
						postNav.classList.remove( 'is-hidden' );
					}
				}

				prevScrollY = scrollY;
				ticking = false;
			} );
		};

		window.addEventListener( 'scroll', onScroll, { passive: true } );
	}
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initPostNavigationScroll );
} else {
	initPostNavigationScroll();
}
